import React from 'react'
import { FormControl, FormControlLabel, Checkbox as MuiCheckbox } from '@material-ui/core';

interface checkboxProps {
    name: string;
    label?: string;
    labelComponent?: React.ReactNode;
    value: boolean;
    onChange: (e: any) => void;
}

export default function Checkbox(props: checkboxProps) {

    const { name, label, value, labelComponent, onChange } = props;

    const convertToDefEventPara = (name: any, value: any) => ({
        target: {
            name, value
        }
    })

    return (
        <FormControl>
            <FormControlLabel
                control={<MuiCheckbox
                    name={name}
                    color="primary"
                    checked={value}
                    onChange={e => onChange(convertToDefEventPara(name, e.target.checked))}
                />}
                label={
                    (
                        labelComponent != null ?
                            labelComponent : label
                    )
                }
            />
        </FormControl>
    )
}
